import React from "react"
import { Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    fontSize: 20,
    lineHeight: "28px",
    fontWeight: "600",
    color: theme.palette.text.main,
    marginBottom: theme.spacing(1.8),
  },
}))

const SectionTitle = ({ children }) => {
  const classes = useStyles()
  return (
    <Typography variant="h2" className={classes.sectionTitle}>
      {children}
    </Typography>
  )
}

export { SectionTitle }
